import React, { Component } from "react";
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import CreateExamMadeEasy from '../components/exam_made_easy/CreateExamMadeEasy';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";


const FETCH_GLOBALS = gql` 
query($institution_id: Int!) {
    globals(institution_id: $institution_id){
        b_e_c_s_data {
            section_id
            class_id
            branch_id
            exam_id
          }
        exams{
            id
            exam
            exam_subjects{
                subject_id
                no_of_questions
            }
            avg_question_time
        }
        globalBranches{
            id
            branch_name
        }
        classes{
            id
            class
        }
        globalSections{
            id
            section_name
            exam_id
            branch_id
            category_id
        }
        subjects{
            id
            subject
            chapters{
                id
                chapter
                topics{
                    id
                    topic
                    # practice_percentage
                }
                class
            }
            state_chapters{
                id
                chapter
                exam_id
                state_topics{
                    id
                    topic
                }
                class
            }
        }
        questionTypes{
            id
            questiontype
        }
        questionTheory{
            id
            question_theory
        }
        complexity{
            id
            complexity
            
        }
    }
}

`;

const FETCH_SECTIONS = gql` 
query($institution_id: Int!) {
    getSections(institution_id: $institution_id){
        id
        section_name
        branch_id
    }
}

`;

const FETCH_EXAMSTANDARDPERCENTAGE = gql` 
query($exam_id: Int) {
    getExamStandardPercentage(exam_id: $exam_id){
        exam_id
        exam_type
        type_of_exam
        easy
        moderate
        difficult
    }
}

`;


const FETCH_EXAMSCHEDULESUBTYPES = gql` 
query($institution_id: Int!,$type: String) {
    getExamScheduleSubTypeQuestions(institution_id: $institution_id,type: $type){
        schedule_type_id
        schedule_sub_type_id
        schedule_sub_type
        adaptive_type_id
    }
}

`;

class ExamMadeEasy extends Component {
    constructor(props) {
        super(props)
        this.state = {
            toggled: Cookies.get("toggle")
        }
    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {
        if (Cookies.get("token") == undefined) this.props.history.push("/login");
        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        const getSections = this.props.getSections;
        const loading2 = getSections.loading;
        const error2 = getSections.error;

        const getExamScheduleSubTypeQuestions = this.props.getExamScheduleSubTypeQuestions;
        console.log("getExamScheduleSubTypeQuestions", getExamScheduleSubTypeQuestions)
        const loading4 = getExamScheduleSubTypeQuestions.loading;
        const error4 = getExamScheduleSubTypeQuestions.error;


        const getExamStandardPercentage = this.props.getExamStandardPercentage;
        const loading3 = getExamStandardPercentage.loading;
        const error3 = getExamStandardPercentage.error;



        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
        if (error3 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
        if (error4 !== undefined) {
            alert("Server Error. " + error4.message);
            return null;
        }

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">

                    <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                        <SideNavbar />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper mb-2">
                        {
                            loading1 ?
                                (
                                    <Container fluid className="exam_made_easy">
                                        <style>{`
                                            @keyframes emeShimmer {
                                                0%   { background-position: -468px 0; }
                                                100% { background-position: 468px 0; }
                                            }
                                            .eme-shimmer {
                                                background: #f1f5f9;
                                                background-image: linear-gradient(90deg, #eef2f7 0px, #f8fafc 40px, #eef2f7 80px);
                                                background-size: 936px 100%;
                                                background-repeat: no-repeat;
                                                border-radius: 8px;
                                                animation: emeShimmer 1.4s linear infinite;
                                            }
                                        `}</style>

                                        {/* Tab bar shimmer */}
                                        <div style={{ background: "#f8fafc", border: "1.5px solid #e2e8f0", borderRadius: 12, padding: "12px 16px", marginTop: 16, display: "flex", gap: 8 }}>
                                            <div className="eme-shimmer" style={{ width: 150, height: 40 }} />
                                            <div className="eme-shimmer" style={{ width: 150, height: 40 }} />
                                        </div>

                                        <Row className="mt-3">
                                            {/* Left: form shimmer */}
                                            <Col sm={9}>
                                                <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 20 }}>
                                                    <Row>
                                                        {[0, 1, 2].map((i) => (
                                                            <Col sm={4} key={i}>
                                                                <div className="eme-shimmer" style={{ width: "60%", height: 12, marginBottom: 10 }} />
                                                                <div className="eme-shimmer" style={{ width: "100%", height: 40, marginBottom: 18 }} />
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                    <div className="eme-shimmer" style={{ width: 180, height: 14, margin: "8px 0 16px" }} />
                                                    <Row>
                                                        {[0, 1, 2].map((i) => (
                                                            <Col sm={4} key={i}>
                                                                <div className="eme-shimmer" style={{ width: "100%", height: 110, marginBottom: 16 }} />
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                    <div className="eme-shimmer" style={{ width: "100%", height: 240, marginTop: 8 }} />
                                                </div>
                                            </Col>
                                            {/* Right: summary shimmer */}
                                            <Col sm={3}>
                                                <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: 20 }}>
                                                    <div className="eme-shimmer" style={{ width: "70%", height: 16, marginBottom: 18 }} />
                                                    {[0, 1, 2, 3, 4].map((i) => (
                                                        <div key={i} style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
                                                            <div className="eme-shimmer" style={{ width: "45%", height: 12 }} />
                                                            <div className="eme-shimmer" style={{ width: "25%", height: 12 }} />
                                                        </div>
                                                    ))}
                                                    <div className="eme-shimmer" style={{ width: "100%", height: 44, marginTop: 20, borderRadius: 8 }} />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                )
                                :
                                (
                                    <CreateExamMadeEasy
                                        globals={globals.globals}
                                        getSections={getSections.getSections}
                                        getExamStandardPercentage={getExamStandardPercentage.getExamStandardPercentage}
                                        getExamScheduleSubTypeQuestions={getExamScheduleSubTypeQuestions.getExamScheduleSubTypeQuestions}
                                    />

                                )
                        }

                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}




export default withRouter(
    compose(

        graphql(FETCH_GLOBALS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    }
                }), name: "globals"
            }),
        graphql(FETCH_SECTIONS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    }
                }), name: "getSections"
            }),
        graphql(FETCH_EXAMSTANDARDPERCENTAGE,
            {
                options: props => ({
                    variables: {
                        exam_id: 0
                    }
                }), name: "getExamStandardPercentage"
            }),
        graphql(FETCH_EXAMSCHEDULESUBTYPES,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid")),
                        type: "Schedule_exam"

                    }
                }), name: "getExamScheduleSubTypeQuestions"
            }),
    )
        (ExamMadeEasy));